import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { SecurityManagement } from '../../components/admin/SecurityManagement';

export function SecurityPage() {
  return (
    <AdminLayout
      title="Sécurité"
      description="Surveillez et gérez la sécurité de la plateforme"
    >
      <SecurityManagement />
    </AdminLayout>
  );
}
